<template>
    <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0 16.32V14.4H1.95V7.68C1.95 6.352 2.35625 5.172 3.16875 4.14C3.98125 3.108 5.0375 2.432 6.3375 2.112V1.44C6.3375 1.04 6.47969 0.7 6.76406 0.42C7.04844 0.14 7.39375 0 7.8 0C8.20625 0 8.55156 0.14 8.83594 0.42C9.12031 0.7 9.2625 1.04 9.2625 1.44V2.112C10.5625 2.432 11.6188 3.108 12.4313 4.14C13.2438 5.172 13.65 6.352 13.65 7.68V14.4H15.6V16.32H0ZM7.8 19.2C7.26375 19.2 6.80469 19.012 6.42281 18.636C6.04094 18.26 5.85 17.808 5.85 17.28H9.75C9.75 17.808 9.55906 18.26 9.17719 18.636C8.79531 19.012 8.33625 19.2 7.8 19.2Z"
            fill="#8796AF" />
    </svg>
</template>
<script>
export default {
    name: "NotificationIcon",
};
</script>
<style scoped></style>
